import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog';
import { CommonButton } from '@/components/ui/common-button';
import { CommonLabel } from '@/components/ui/common-label';

const DeleteVehicleDialog = ({ open, onOpenChange, vehicle, onDeleteVehicle }) => {
  const [isDeleting, setIsDeleting] = useState(false);

  if (!vehicle) return null;

  const handleDelete = async () => {
    setIsDeleting(true);
    try {
      await onDeleteVehicle(vehicle);
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Delete Vehicle</DialogTitle>
        </DialogHeader>
        <div className="py-4">
          <CommonLabel size="sm" weight="medium">
            Are you sure you want to delete the vehicle <span className="font-bold uppercase">{vehicle.vehicleNumber}</span>? 
            This action cannot be undone.
          </CommonLabel>
        </div>
        <DialogFooter className="flex justify-end space-x-2">
          <CommonButton 
            variant="outline" 
            onClick={() => onOpenChange(false)}
            disabled={isDeleting}
          >
            Cancel
          </CommonButton>
          <CommonButton 
            variant="destructive" 
            onClick={handleDelete}
            disabled={isDeleting}
          >
            {isDeleting ? 'Deleting...' : 'Delete'}
          </CommonButton>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteVehicleDialog;